/**
 * A small usage line for a studio header: "12 of 30 decks this month". Nothing for staff (never capped) or while
 * /v1/me loads. Amber from 80%, and it says when the month starts again once the cap is reached.
 */
import { cn } from '@/components/ui/utils';
import { capLabel, resetDay } from './caps';
import { useCap } from './useCoworkMe';

export function CapMeter({ studio, unit, className }: { studio: string; unit: string; className?: string }) {
  const cap = useCap(studio, unit);
  if (!cap) return null;
  const day = resetDay(cap.resetsAt);
  return (
    <span
      data-testid={`cap-meter-${studio}-${unit}`}
      data-state={cap.reached ? 'reached' : cap.near ? 'near' : 'ok'}
      title={day ? `Starts again on ${day}` : undefined}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[12px] leading-5 whitespace-nowrap',
        cap.reached
          ? 'border-[#fecdca] bg-[#fef3f2] text-[#b42318]'
          : cap.near
            ? 'border-[#fedf89] bg-[#fffaeb] text-[#b54708]'
            : 'border-[#eaecf0] bg-white text-[#475467]',
        className,
      )}
    >
      <span>{capLabel(cap)}</span>
      {cap.reached && day ? <span className="text-[#667085]">(starts again {day})</span> : null}
    </span>
  );
}
